import styled from 'styled-components';

import { colors } from '@crm-framework/theme';
import { classNameWithPrefix } from '@crm-framework/utils';

import { INotificationGridCellProps } from './types';

const blockName = 'notifications-grid';

export const NotificationsGridWrapper = styled.div.attrs({
  className: blockName,
})`
  flex: 1;
  overflow: hidden;
  position: relative;
  border: 1px solid ${colors.DEFAULT_BORDER};
  border-radius: 3px;
`;

export const NotificationsGridLoaderWrapper = styled.div.attrs({
  className: classNameWithPrefix(blockName, 'loader'),
})`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8);
`;

export const NotificationsFooter = styled.div.attrs({
  className: classNameWithPrefix(blockName, 'footer'),
})`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

export const NotificationsButtonGroup = styled.div.attrs({
  className: classNameWithPrefix(blockName, 'button-group'),
})`
  display: flex;
`;

export const NotificationsPaginationWrapper = styled.div.attrs({
  className: classNameWithPrefix(blockName, 'pagination'),
})`
  display: flex;
  align-items: center;
`;

export const NotificationGridGeneralSelectCheckboxWrapper = styled.div.attrs({
  className: classNameWithPrefix(blockName, 'general-select-checkbox'),
})`
  display: flex;
`;

export const NotificationGridCell = styled.div.attrs({
  className: classNameWithPrefix(blockName, 'cell'),
})<INotificationGridCellProps>`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  background: ${({ isRead }) => (isRead ? colors.N30 : 'transparent')};
  font-weight: ${({ isRead }) => (isRead ? 400 : 600)};
`;

export const NotificationMessage = styled.div.attrs({
  className: classNameWithPrefix(blockName, 'message'),
})`
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 5px;
  display: flex;
  flex: no-wrap;
  justify-content: flex-start;
`;

export const NotificationText = styled.span.attrs({
  className: classNameWithPrefix(blockName, 'text'),
})`
  white-space: normal;
`;

export const NotificationActionsWrapper = styled.div.attrs({
  className: classNameWithPrefix(blockName, 'actions'),
})`
  margin-left: auto;
`;
